const objectPosition = {
    name: "object-position",
    path: "/object-position",
    title: "object-position",
    description: "Utilities for controlling how a replaced element's content should be positioned within its container.",
    value: {
        "object-position": {
            "object-center": "center",
            "object-top": "top",
            "object-bottom": "bottom",
            "object-left": "left",
            "object-right": "right",
            "object-top-left": "top left",
            "object-top-right": "top right",
            "object-bottom-left": "bottom left",
            "object-bottom-right": "bottom right",
            "object-[<value>]": "<value>",
        }
    },
    exampleData: [
        {
            "title": "object-left, object-bottom-right",
            "description": "to specify how a replaced element's content should be positioned within its container:",
            "moreDescription": "",
            "parentClass": "!bg-none flex snap-x scroll-p-4 items-end overflow-x-scroll overflow-y-hidden p-8 py-12 sm:grid sm:grid-columns-3 sm:gap-16",
            "example": {
                "element": "img",
                "src": [
                    {
                        "src": "https://fastly.picsum.photos/id/249/96/96.jpg?hmac=42Tc9bFAZ_evsHgDL3vH5cNlNYueX4W5EZRxoHLoc0s",
                        "className": "object-top-left  object-none w-full rounded-md",
                        "text": "object-top-left",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/249/96/96.jpg?hmac=42Tc9bFAZ_evsHgDL3vH5cNlNYueX4W5EZRxoHLoc0s",
                        "className": "object-top object-none w-full rounded-md",
                        "text": "object-top",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/249/96/96.jpg?hmac=42Tc9bFAZ_evsHgDL3vH5cNlNYueX4W5EZRxoHLoc0s",
                        "className": "object-top-right object-none w-full rounded-md",
                        "text": "object-top-right",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/249/96/96.jpg?hmac=42Tc9bFAZ_evsHgDL3vH5cNlNYueX4W5EZRxoHLoc0s",
                        "className": "object-left object-none w-full rounded-md",
                        "text": "object-left",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/249/96/96.jpg?hmac=42Tc9bFAZ_evsHgDL3vH5cNlNYueX4W5EZRxoHLoc0s",
                        "className": "object-center object-none w-full rounded-md",
                        "text": "object-center",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/249/96/96.jpg?hmac=42Tc9bFAZ_evsHgDL3vH5cNlNYueX4W5EZRxoHLoc0s",
                        "className": "object-right object-none w-full rounded-md",
                        "text": "object-right",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/249/96/96.jpg?hmac=42Tc9bFAZ_evsHgDL3vH5cNlNYueX4W5EZRxoHLoc0s",
                        "className": "object-bottom-left object-none w-full rounded-md",
                        "text": "object-bottom-left",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/249/96/96.jpg?hmac=42Tc9bFAZ_evsHgDL3vH5cNlNYueX4W5EZRxoHLoc0s",
                        "className": "object-bottom object-none w-full rounded-md",
                        "text": "object-bottom",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/249/96/96.jpg?hmac=42Tc9bFAZ_evsHgDL3vH5cNlNYueX4W5EZRxoHLoc0s",
                        "className": "object-bottom-right object-none w-full rounded-md",
                        "text": "object-bottom-right",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",
                    }
                ],
                "className": "relative mx-auto size-32 bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700",
                "code": `
<img class="object-none w-full object-top-left ..." src="/img/mountains.jpg" />
<img class="object-none w-full object-top ..." src="/img/mountains.jpg" />
<img class="object-none w-full object-top-right ..." src="/img/mountains.jpg" />
<img class="object-none w-full object-left ..." src="/img/mountains.jpg" />
<img class="object-none w-full object-center ..." src="/img/mountains.jpg" />
<img class="object-none w-full object-right ..." src="/img/mountains.jpg" />
<img class="object-none w-full object-bottom-left ..." src="/img/mountains.jpg" />
<img class="object-none w-full object-bottom ..." src="/img/mountains.jpg" />
<img class="object-none w-full object-bottom-right ..." src="/img/mountains.jpg" />
                `
            },
        },
        {
            "title": "object-[<value>]",
            "description": "syntax to set the object position based on a completely custom value:",
            "moreDescription": "",
            "parentClass": "!bg-none flex snap-x scroll-p-4 items-end overflow-x-scroll overflow-y-hidden p-8 py-12 sm:grid sm:grid-columns-3 sm:gap-16",
            "example": {
                "element": "img",
                "src": [
                    {
                        "src": "https://fastly.picsum.photos/id/249/96/96.jpg?hmac=42Tc9bFAZ_evsHgDL3vH5cNlNYueX4W5EZRxoHLoc0s",
                        "className": "object-[25%_75%] object-none w-full rounded-md",
                        "text": "object-[25%_75%]",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",
                    }
                ],
                "className": "relative mx-auto size-32 bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700",
                "code": `
<img class="object-[25%_75%] object-none w-full ..." src="/img/mountains.jpg" />
                `
            },
        }
    ],
};

export default objectPosition;